angular
    .module('dnecom.component.product')
    .directive('productRegularPrice', ["$parse", "CurrencyConverter", "CurrencyRates", "CurrencyFormatter", function ($parse, CurrencyConverter, CurrencyRates, CurrencyFormatter) {
        function formatPrice(price, currencyCode, currencyRate) {
            if (!price) {
                return '';
            }

            return CurrencyFormatter.format(
                CurrencyConverter.convert(
                    price,
                    currencyRate
                ), 
                currencyCode
            );
        };

        return {
            link: function (scope, element, attrs) {
                var product = $parse(attrs.productRegularPrice)(scope),
                    regularPrice = null;
                
                if (product.hasSavings) {
                    regularPrice = (!_.isNull(product.minRegularPrice))
                        ? parseFloat(product.minRegularPrice).toFixed(2)
                        : null;
                }

                CurrencyRates.fetchCurrentRate().then(function(currency) {
                    element.text(formatPrice(regularPrice, currency.code, currency.rate));
                });

                scope.$on('currency.convert', function (e, currency) {
                    element.text(formatPrice(regularPrice, currency.code, currency.rate));
                });
            }
        };
    }]);
